// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2NFdK","modalForm":"UpgradeEpcsModal_modalForm__2HF5h","modalFooter":"UpgradeEpcsModal_modalFooter__22biE"};